export default "__VITE_ASSET__d6333edd__"